import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import ROUTES from "../../Utils/routesConstants";
import {
  getToken,
  GET_APPOINMENT_DETAILS,
  GET_APPOINMENT_QUEUE_DETAILS,
  GET_TOTAL_COUNT,
  GET_MER_LIBRARY,
  GET_APPOINMENT_TIME_SLOT,
  GET_APPOINMENT_HISTORY,
  GET_APPOINMENT_UPLOAD_REPORT,
  IS_SHOW_POPUP,
  GET_PROVIDER_NAME_DETAILS,
  GET_CLIENT_NAME_DETAILS,
  getRole,
  getNetworkMenuId,
  GET_APPOINTMENT_COUNT,
  GET_STATUS_REASON,
  GET_WHATSAPP_APPOINTMENT_DETAILS,
  GET_WHATSAPP_APPOINMENT_UPLOAD_REPORT,
  GET_PROVIDERDETAILS,
  GET_WHATSAPP_STATUS_REASON,
  PARTIAL_TEST_DETAIL,
} from "../../Utils/types";

export const getAppoinmentAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url =
    getRole() === "NetworkAdmin"
      ? `${API_URL_WITHOUT_USER}/Network/GetAppointmentManagementProvidersDetails`
      : `${API_URL_WITHOUT_USER}/AppointmentQueue/GetAppointmentQueue`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getRole() === "NetworkAdmin" &&
      getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      if (getRole() === "NetworkAdmin") {
        getDispatch(
          GET_APPOINMENT_QUEUE_DETAILS,
          res?.data?.results?.apointmentmanagementList,
          dispatch
        );
      } else {
        getDispatch(
          GET_APPOINMENT_QUEUE_DETAILS,
          res?.data?.results?.apointmentQueueList,
          dispatch
        );
      }
      getDispatch(GET_APPOINMENT_DETAILS, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_APPOINMENT_QUEUE_DETAILS, null, dispatch);
      getDispatch(GET_APPOINMENT_DETAILS, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
export const GetPartialTestDetailsList = (id,vt) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = getRole() === "NetworkAdmin"
  ?`${API_URL_WITHOUT_USER}/Network/GetPartialTestDetailsList?appointmentId=${id}&Target=${vt}`:
  `${API_URL_WITHOUT_USER}/AppointmentQueue/GetPartialTestDetailsList?appointmentId=${id}&Target=${vt}`
      
  return HttpUtil.makeGET(url, {}, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:  getRole() === "NetworkAdmin" &&
    getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
    getNetworkMenuId()?.menuId,
     
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(PARTIAL_TEST_DETAIL, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(PARTIAL_TEST_DETAIL, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const getAppointmentQueueFilterCountsAction = (e) => (dispatch) => {
  const url =
    getRole() === "NetworkAdmin"
      ? `${API_URL_WITHOUT_USER}/Network/GetAppointmentManagementFilterCounts`
      : `${API_URL_WITHOUT_USER}/AppointmentQueue/GetAppointmentQueueFilterCounts`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getRole() === "NetworkAdmin" &&
      getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_APPOINTMENT_COUNT, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_APPOINTMENT_COUNT, null, dispatch);
    }
  });
};

export const getExportAppoinmentExcelAction = (e) => (dispatch) => {
  const url =
    getRole() === "NetworkAdmin"
      ? `${API_URL_WITHOUT_USER}/Network/GetAppointmentManagementProvidersDetails`
      : `${API_URL_WITHOUT_USER}/AppointmentQueue/GetAppointmentQueue`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getRole() === "NetworkAdmin" &&
      getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
      getNetworkMenuId()?.menuId,
  });
};

export const getMERLibraryAction = (pageNumber) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/AppointmentQueue/GetMERClientList?page=${pageNumber}&limit=8`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_MER_LIBRARY, res?.data?.results?.merList, dispatch);
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalrow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_MER_LIBRARY, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const updateAppoinmentPartialStatusAction =
  (
    e,
 
  ) =>
  (dispatch) => {
    const url =
      getRole() === "NetworkAdmin"
        ? `${API_URL_WITHOUT_USER}/Network/UpdateAppointmentDCConfirmationStageNetwork`
        : `${API_URL_WITHOUT_USER}/AppointmentQueue/UpdateAppointmentDCConfirmationStage`;
    return HttpUtil.makePOST(url, e, {
      Authorization: getToken(),
      ApiKey: API_KEY,
      MenuId:
        getRole() === "NetworkAdmin" &&
        getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
        getNetworkMenuId()?.menuId,
    }).then((res) => {
     return res
    });
  };
export const updateAppoinmentStatusAction =
  (
    e,
    getAppoinmentAction,
    searchFilter,
    apiParams,
    setIsUploadReportPopup,
    setIsConfirmationPopup,
    setIsRejectPopup
  ) =>
  (dispatch) => {
    const url =
      getRole() === "NetworkAdmin"
        ? `${API_URL_WITHOUT_USER}/Network/UpdateAppointmentDCConfirmationStageNetwork`
        : `${API_URL_WITHOUT_USER}/AppointmentQueue/UpdateAppointmentDCConfirmationStage`;
    return HttpUtil.makePOST(url, e, {
      Authorization: getToken(),
      ApiKey: API_KEY,
      MenuId:
        getRole() === "NetworkAdmin" &&
        getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
        getNetworkMenuId()?.menuId,
    }).then((res) => {
      if (res?.data?.status === true) {
        getDispatch(IS_SHOW_POPUP, true, dispatch);
        res?.data?.message !== "All Validations passed." &&
          getSnackbarSuccess(
            "success",
            "The appointment status is successfully updated.",
            dispatch
          );
      } else {
        getDispatch(IS_SHOW_POPUP, false, dispatch);
        setIsUploadReportPopup(null);
        setIsConfirmationPopup(null);
        setIsRejectPopup(null);
        dispatch(getAppoinmentAction({ ...searchFilter, ...apiParams }));
        getSnackbarSuccess("info", res?.data?.message, dispatch);
      }
      return res
    });
  };

export const reportUploadFileAction = (formData, valueType) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url =
    getRole() === "NetworkAdmin"
      ? `${API_URL_WITHOUT_USER}/Network/ReportUpload`
      : `${API_URL_WITHOUT_USER}/FileManager/ReportUploadFile?ValueType=${valueType}`;
  return HttpUtil.makePOST(url, formData, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getRole() === "NetworkAdmin" &&
      getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
    } else {
      isLoadingAction(false, dispatch);
    }
  });
};

export const getAppoinmentTimeSlotAction =
  (appointmentId, valueType) => (dispatch) => {
    const url = `${API_URL_WITHOUT_USER}/AppointmentQueue/GetProviderTimeSlots?AppointmentId=${appointmentId}&ValueType=${valueType}`;
    return HttpUtil.makeGET(
      url,
      {},
      {
        ApiKey: API_KEY,
        Authorization: getToken(),
      }
    ).then((res) => {
      if (res?.data?.status === true) {
        getDispatch(GET_APPOINMENT_TIME_SLOT, res?.data?.results, dispatch);
      } else {
        getDispatch(GET_APPOINMENT_TIME_SLOT, null, dispatch);
      }
    });
  };

export const updateRejectStatusAction =
  (
    e,
    getAppoinmentAction,
    searchFilter,
    apiParams,
    setIsUploadReportPopup,
    setIsConfirmationPopup,
    setIsRejectPopup
  ) =>
  (dispatch) => {
    const url =
      getRole() === "NetworkAdmin"
        ? `${API_URL_WITHOUT_USER}/Network/AppointmentConfirmationByNetworkPost`
        : `${API_URL_WITHOUT_USER}/AppointmentQueue/AppointmentConfirmationByProvider`;
    return HttpUtil.makePOST(url, e, {
      Authorization: getToken(),
      ApiKey: API_KEY,
      MenuId:
        getRole() === "NetworkAdmin" &&
        getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
        getNetworkMenuId()?.menuId,
    }).then((res) => {
      if (res?.data?.results?.scheduleStatus === "True") {
        getDispatch(IS_SHOW_POPUP, true, dispatch);
        res?.data?.results?.isApproved !== "SHOWPOPUP" &&
          getSnackbarSuccess(
            "success",
            "The appointment status is successfully updated.",
            dispatch
          );
      } else {
        getDispatch(IS_SHOW_POPUP, false, dispatch);
        setIsUploadReportPopup(null);
        setIsConfirmationPopup(null);
        setIsRejectPopup(null);
        dispatch(getAppoinmentAction({ ...searchFilter, ...apiParams }));
        getSnackbarSuccess("info", res?.data?.results?.errorMessage, dispatch);
      }
    });
  };

export const deleteReportUploadAction = (e) => (dispatch) => {
  const url =
    getRole() === "NetworkAdmin"
      ? `${API_URL_WITHOUT_USER}/Network/DeleteUploadReportFileNetwork`
      : `${API_URL_WITHOUT_USER}/AppointmentQueue/DeleteUploadReportFile`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId:
      getRole() === "NetworkAdmin" &&
      getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
      getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", "Report deleted successfully", dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const getAppoinmentHistoryAction =
  (appointmentId, valueType) => (dispatch) => {
    const url = `${API_URL_WITHOUT_USER}/AppointmentQueue/GetAppointmentHistory?AppointmentId=${appointmentId}&ValueType=${valueType}`;
    return HttpUtil.makeGET(
      url,
      {},
      {
        ApiKey: API_KEY,
        Authorization: getToken(),
      }
    ).then((res) => {
      if (res?.data?.status === true) {
        getDispatch(
          GET_APPOINMENT_HISTORY,
          res?.data?.results?.appointmentHistoryList,
          dispatch
        );
      } else {
        getDispatch(GET_APPOINMENT_HISTORY, null, dispatch);
      }
    });
  };

export const getAppoinmentReportUploadAction =
  (valueType, appointmentId) => (dispatch) => {
    const url = `${API_URL_WITHOUT_USER}/AppointmentQueue/GetFilePath?ValueType=${valueType}&AppointmentId=${appointmentId}`;
    return HttpUtil.makeGET(
      url,
      {},
      {
        ApiKey: API_KEY,
        Authorization: getToken(),
        MenuId:
          getRole() === "NetworkAdmin" &&
          getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
          getNetworkMenuId()?.menuId,
      }
    ).then((res) => {
      if (res?.data?.status === true) {
        getDispatch(GET_APPOINMENT_UPLOAD_REPORT, res?.data, dispatch);
      } else {
        getDispatch(GET_APPOINMENT_UPLOAD_REPORT, null, dispatch);
      }
    });
  };

export const getProviderNameAction = (name) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/Network/GetProvidersList?ProviderName=${name}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PROVIDER_NAME_DETAILS, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_PROVIDER_NAME_DETAILS, null, dispatch);
    }
  });
};

export const getClientNameAction = (name) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/Network/GetAllCientsList?ClientName=${name}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_CLIENT_NAME_DETAILS, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_CLIENT_NAME_DETAILS, null, dispatch);
    }
  });
};

export const getAppointmentDetailPrintById = (params) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url =
    getRole() === "NetworkAdmin"
      ? `${API_URL_WITHOUT_USER}/Network/GetAppointmentDetails?AppointmentId=${params?.AppointmentId}&ValueType=${params?.valueType}`
      : `${API_URL_WITHOUT_USER}/AppointmentQueue/GetAppointmentDetails?AppointmentId=${params?.AppointmentId}&ValueType=${params?.valueType}`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: getToken(),
    }
  );
};

export const acceptAllCaseAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url =
    getRole() === "NetworkAdmin"
      ? `${API_URL_WITHOUT_USER}/Network/AppointmentConfirmationByNetworkMultiple`
      : `${API_URL_WITHOUT_USER}/AppointmentQueue/AppointmentConfirmationByProviderMultiple`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId:
      getRole() === "NetworkAdmin" &&
      getNetworkMenuId()?.url === ROUTES?.APPOINMENT_MANAGEMENT &&
      getNetworkMenuId()?.menuId,
  })
    .then((res) => {
      if (res?.data?.status === true) {
        getSnackbarSuccess(
          "success",
          `${res?.data?.results?.successCount} Appointments is confirmed out of ${res?.data?.results?.totalAppointments} Appointments`,
          dispatch
        );
        isLoadingAction(false, dispatch);
      } else {
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
      }
    })
    .catch((err) => isLoadingAction(false, dispatch));
};

export const getStatusReasonAction = (e) => (dispatch) => {
  const url =
    getRole() === "NetworkAdmin"
      ? `${API_URL_WITHOUT_USER}/Network/GetStatusReasonNetwork`
      : `${API_URL_WITHOUT_USER}/AppointmentQueue/GetStatusReason`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_STATUS_REASON, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_STATUS_REASON, [], dispatch);
    }
  });
};

export const getWhatsappAppointmentActions = (e, params) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/AppointmentActions/GetAppointmentActions/${params?.token}`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_WHATSAPP_APPOINTMENT_DETAILS,
        res?.data?.results?.apointmentActionList,
        dispatch
      );
      getDispatch(
        GET_PROVIDERDETAILS,
        res?.data?.results?.providerLogo,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_WHATSAPP_APPOINTMENT_DETAILS, [], dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const updateWhatsappAppoinmentStatusAction =
  (e, params) => (dispatch) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/AppointmentActions/AddUpdateAppointmentActionsDCConfirmation/${params?.token}/${params?.source}`;
    return HttpUtil.makePOST(url, e, {
      ApiKey: API_KEY,
    }).then((res) => {
      if (res?.data?.status === true) {
        getSnackbarSuccess(
          "success",
          "The appointment status is successfully updated.",
          dispatch
        );
        isLoadingAction(false, dispatch);
      } else {
        getSnackbarSuccess("info", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
      }
    });
  };

export const getWhatsappAppoinmentReportUploadAction =
  (actionToken, valueType, appointmentId) => (dispatch) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/AppointmentActions/AppointmentActionGetFilePath/${actionToken}/?ValueType=${valueType}&AppointmentId=${appointmentId}`;
    return HttpUtil.makeGET(
      url,
      {},
      {
        ApiKey: API_KEY,
      }
    ).then((res) => {
      if (res?.data?.status === true) {
        getDispatch(GET_WHATSAPP_APPOINMENT_UPLOAD_REPORT, res?.data, dispatch);
        isLoadingAction(false, dispatch);
      } else {
        getDispatch(GET_WHATSAPP_APPOINMENT_UPLOAD_REPORT, null, dispatch);
        isLoadingAction(false, dispatch);
      }
    });
  };

export const deleteWhatsappReportUploadAction = (params, e) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/AppointmentActions/AppointmentActionDeleteUploadFile/${params?.token}/${params?.source}`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      getSnackbarSuccess("success", "Report deleted successfully", dispatch);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const whatsappReportUploadFileAction =
  (params, formData, valueType) => (dispatch) => {
    isLoadingAction(true, dispatch);
    const url = `${API_URL_WITHOUT_USER}/AppointmentActions/AppointmentActionReportUpload/${params?.token}/${params?.source}?ValueType=${valueType}`;
    return HttpUtil.makePOST(url, formData, {
      ApiKey: API_KEY,
    }).then((res) => {
      if (res?.data?.status === true) {
        isLoadingAction(false, dispatch);
      } else {
        isLoadingAction(false, dispatch);
      }
    });
  };

export const getWhatsappStatusReasonAction = (e, params) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/AppointmentActions/AppointmentActionGetStatusReason?ActionToken=${params?.token}`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_WHATSAPP_STATUS_REASON, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_WHATSAPP_STATUS_REASON, [], dispatch);
    }
  });
};

export const checkStatuseWhatsappAppoinmentStatusAction =
  (e, params) => (dispatch) => {
    const url = `${API_URL_WITHOUT_USER}/AppointmentActions/AddUpdateAppointmentActionsDCConfirmation/${params?.token}/${params?.source}`;
    return HttpUtil.makePOST(url, e, {
      ApiKey: API_KEY,
    });
  };
